export default "__VITE_ASSET__el0N1tFU__"